import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useGlobal } from '@/contexts/GlobalContext';
import { getCurrentTeamTabMenu } from '@/utils/getCurrentTeamTabMenu';
import { TeamTabMenu } from '@/types/menu';

export function useCurrentTeamTabMenu() {
  const location = useLocation();
  const navigate = useNavigate();
  const context = useGlobal();
  const [currentMenu, setCurrentMenu] = useState<TeamTabMenu | undefined>();
  const [menuItems, setMenuItems] = useState<{ label: React.ReactNode; onClick: () => void }[]>([]);
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // チームオーナーかどうか
  const isTeamOwner = () => {
    if (!context.team) return false;
    return context.user?.id === context.team?.owner_id;
  };

  const handleMoveTo = (path: string) => {
    navigate(path);
  };

  useEffect(() => {
    const menu = getCurrentTeamTabMenu(location.pathname);
    setCurrentMenu(menu);
    setMenuItems(getMenuItemsForCurrentMenu(menu));
    setActiveIndex(getActiveIndexForCurrentMenu(menu));
    // MOTE:context.isTeamPageを依存配列に入れないとチームページでURL直叩きでタブが表示されなくなる
  }, [location.pathname, context.isTeamPage]);

  const getActiveIndexForCurrentMenu = (menu: TeamTabMenu | undefined) => {
    switch (menu) {
      case 'HOME':
        return 0;
      case 'TEAM_NOTE':
        return 0;
      case 'GOALS':
        return 1;
      case 'MEMBER':
        return 0;
      case 'MEMBER_SETTINGS':
        return 1;
      default:
        return 0;
    }
  };

  const getMenuItemsForCurrentMenu = (menu: TeamTabMenu | undefined) => {
    switch (menu) {
      case 'HOME':
        return [
          {
            label: <>HOME</>,
            onClick: () => handleMoveTo(`/teams/${context.team?.uuid}`)
          }
        ];
      case 'TEAM_NOTE':
      case 'GOALS':
        return [
          {
            label: <>サッカーノート</>,
            onClick: () => handleMoveTo(`/teams/${context.team?.uuid}/notes`)
          },
          {
            label: <>目標・課題</>,
            onClick: () => handleMoveTo(`/teams/${context.team?.uuid}/goals`)
          }
        ];
      case 'MEMBER':
      case 'MEMBER_SETTINGS':
        if (isTeamOwner()) {
          return [
            {
              label: <>所属メンバー</>,
              onClick: () => handleMoveTo(`/teams/${context.team?.uuid}/members`)
            },
            {
              label: (
                <>
                  <div className="me-2">メンバー検索・管理</div>
                </>
              ),
              onClick: () => handleMoveTo(`/teams/${context.team?.uuid}/members/settings`)
            }
          ];
        } else {
          return [
            {
              label: <>所属メンバー</>,
              onClick: () => handleMoveTo(`/teams/${context.team?.uuid}/members`)
            }
          ];
        }
      default:
        return [];
    }
  };
  return { currentMenu, menuItems, activeIndex };
}
